import { TTicketContract } from '@controllers/EthereumController/Public/handleAssetInfoController'
import { IFakturaMypinataResponse, IMetadataProperties } from '@types'

import { conversionUtils } from '..'

const getAmount = (rarity: string): number => {
    if (rarity === 'Exclusive') {
        const FIVE = 5
        return FIVE
    }
    if (rarity === 'Super Rare') {
        const TEN = 10
        return TEN
    }
    if (rarity === 'Rare') {
        const TWENTY_FIVE = 25
        return TWENTY_FIVE
    }
    if (rarity === 'Limited') {
        const FIFTY = 50
        return FIFTY
    }
    if (rarity === 'Standard') {
        const HUNDRED = 100
        return HUNDRED
    }
    const HUNDRED_FIFTY = 150
    return HUNDRED_FIFTY
}

export const handleAssetInfo = async (
    resultMint: Record<string, any>,
    ticket: TTicketContract,
): Promise<IMetadataProperties[]> => {
    const { ipfsToHTTP } = conversionUtils

    const metadata = [] as IMetadataProperties[]
    const transfer = resultMint.events.Transfer
    const temporaryArray = []
    if (Array.isArray(transfer)) {
        for (const element of transfer) {
            temporaryArray.push(element.returnValues.tokenId)
        }
    } else {
        temporaryArray.push(resultMint.events.Transfer.returnValues.tokenId)
    }

    for (const element of temporaryArray) {
        const resultURI = await ticket.methods.tokenURI(element).call()

        const response = await fetch(ipfsToHTTP(resultURI))

        console.log(response)
        const body = (await response.json()) as IFakturaMypinataResponse

        if (body.traits) {
            metadata.push({
                image: ipfsToHTTP(body.image),
                name: body.name,
                description: body.description,
                total_cnt_by_type: getAmount(body.traits[0].value),
                token_type: body.traits[0].value,
                animation_url: ipfsToHTTP(body.animation_url),
            })
        } else {
            metadata.push({
                image: ipfsToHTTP(body.image),
                name: body.name,
                description: body.description,
                total_cnt_by_type: undefined,
                token_type: undefined,
                animation_url: ipfsToHTTP(body.animation_url),
            })
        }
    }

    return metadata
}
